<template>
    <div class="card">
        <div class="card-header">
            <h3 class="card-title" >Event <span class="badge badge-info">#{{ f.event_id }}</span></h3>
        </div>
        <div class="card-body" style="padding: 10px 10px 0px;">
            <div class="container-comments">
                <ul v-if="notesList.length > 0" class="listComments">
                    <li v-for="(i, idx) in notesList" :key="idx">
                        <div :class="['comments-content', idx == 0 ? 'last-comment' : '']">
                            <div class="comment-avatar">
                                <div class="label-assign">
                                    <div  :class="['avatarUser', (i.author.avatar!=null) ? 'avatarImg' : '']" :style="(i.author.avatar==null) ? 'background-color:'+i.author.classColor+';' : ''"
                                    >
                                        <img v-if="i.author.avatar" :src="i.author.avatar" class="imgAvatar">
                                        <span class="labelAvatar" v-else>
                                            {{i.author.pref_name}}
                                        </span>
                                    </div>
                                </div>
                                <div class="comment-info">
                                    <div class="date">Date: {{ i.date }} {{ i.hours }} </div>
                                    <div class="by">By: {{ i.author_by }}</div>
                                </div>
                            </div>
                            <div class="comment-body">
                                <div class="comment">{{ i.comment }}</div>
                            </div>
                            <button class="closeIcon" @click="delNote(i.id)"><span></span></button>
                        </div>
                    </li>
                </ul>
                <div v-else-if="!is_waiting" style="padding-top: 20px;">
                    <div class="alert alert-info" role="alert">
                        Post notes or comments about this project
                    </div>
                </div>
                <div v-else style="padding-top: 20px;">
                    <div class="alert alert-default" role="alert">
                        Waiting for comments...
                    </div>
                </div>
            </div>
            <form @submit.prevent="saveNotes">
                <table class="table table-bordered" style="border:0px; margin-bottom: 0px;">
                    <tbody>
                        <tr>
                            <td rowspan="3" style="width: 60%;">
                                <textarea v-model="f.comment" class="form-control" style="height: 100px;"
                                    placeholder="Comments" required></textarea>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <input type="text" class="form-control" :value="profile" placeholder="Author"
                                    disabled="true">
                            </td>
                        </tr>
                        <tr>
                            <td class="text-left">
                                <button type="submit" class="btn btn-success" style="width: 100%;">Save</button>
                            </td>
                        </tr>
                        <tr>
                            <td class="text-left">
                                <!--<span style="margin-right: 20px;"><i class="fa fa-image"></i></span>
								<span><i class="fas fa-paperclip"></i></span>-->
                            </td>
                        </tr>
                    </tbody>
                </table>
            </form>
        </div>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
    name: 'eventNotes',
    data() {
        return {
            f: {
                user_id: window.master_client,
                org_id: window.localorgdata,
                author_user_id: window.localAccountID,
                event_id: 0,
                comment: '',
            },
            notesList: [],
            profile: {},
            is_waiting: true,
        }
    },
    created() {
        let t = this;
        this.getUsersList().then(() => {
            t.init();
        });
    },
    methods: {
        init() {
            let t = this;
            t.profile = this.getProfile(window.localAccountID);
            let d = t.$store.getters['core/getOpenModal'].data;
            t.f.event_id= d.event_id ?? 0;
            if(t.f.event_id==0){
                t.$store.commit("core/setNotiPush", {
                    show: true,
                    group: "notiPush",
                    type: '5', // 1=success|2=info|3=error|4=loading|5=warning
                    title: 'Failed!',
                    text: 'Event ID not found',
                    duration: 5000
                });
                t.close();
            }
            document.querySelector('body').classList.add('overflowYhide');
            t.getNotes(true);
        },
        getNotes(isLoad) {
            let t = this;
            if(isLoad) {t.$store.commit("core/setLoadingModal", true);}
            window.master
                .post('bRem/getNotesEvent', t.f)
                .then((response) => {
                    console.log('getNotesEvent', response.data)
                    t.notesList = response.data.notes.map(item => ({
                        ...item,
                        date: new Intl.DateTimeFormat("en-US", {
                            year: "numeric",
                            month: "short", // "Sep"
                            day: "2-digit", // "03"
                        }).format(new Date(item.created_at)),
                        hours: new Intl.DateTimeFormat("en-US", {
                            hour: "2-digit",
                            minute: "2-digit",
                            hour12: true // formato AM/PM
                        }).format(new Date(item.created_at)),
                        author_by: t.printAuthor(item.author_user_id) ? t.printAuthor(item.author_user_id).firstname+' '+t.printAuthor(item.author_user_id).lastname : 'S/N',
                        author: t.printAuthor(item.author_user_id),
                    }));
                    console.log('notesList', t.notesList);
                    t.$store.commit("core/setLoadingModal", false);
                    t.f.comment = '';
                    t.is_waiting = false;
                    setTimeout(function () {
                        let scroll = document.querySelector(".container-comments");
                        // scroll.scrollTop=scroll.scrollHeight;
                    }, 200);
                })
                .catch((error) => {
                    console.log(error);
                    t.$store.commit("core/setLoadingModal", false);
                    t.is_waiting = false;
                });
        },
        saveNotes() {
            let t = this;
            t.$store.commit("core/setLoadingModal", true);
            let url ="bRem/addNoteEvent";
            if(t.f.id>0){url="bRem/updateNoteEvent";}
            window.master
                .post(url, t.f)
                .then((response) => {
                    console.log('setNotesSales', response.data)
                    if(!response.data.success){
                        let error = response.data.errors ?? [];
                        if(error.length>0){
                            t.$store.commit("core/setNotiPush", {
                                show: true,
                                group: "notiPush",
                                type: '5', // 1=success|2=info|3=error|4=loading|5=warning
                                title: 'Failed!',
                                text: error[0],
                                duration: 5000
                            });
                        }
                        else if(response.data.message && response.data.message.length>0){
                            t.$store.commit("core/setNotiPush", {
                                show: true,
                                group: "notiPush",
                                type: '5', // 1=success|2=info|3=error|4=loading|5=warning
                                title: 'Failed!',
                                text: response.data.message,
                                duration: 5000
                            });
                        }
                    } else {
                        let pushRefresh = this.$store.getters["ModApps/bRem/get_refresh_list"] + 1;
                        this.$store.commit("ModApps/bRem/set_refresh_list", pushRefresh);
                        this.getNotes(false);
                    }
                })
                .catch((error) => {
                    console.log(error);
                    //t.$refs.addGalley.value=null;
                    t.$store.commit("core/setLoadingModal", false);
                });
        },
        delNote(note_id) {
            let t = this;
            t.$store.commit("core/setLoadingModal", true);
            let url ="bRem/deleteNoteEvent";
            window.master
                .post(url, {note_id: note_id})
                .then((response) => {
                    console.log('deleteNoteEvent', response.data)
                    if(!response.data.success){
                        let error = response.data.errors ?? [];
                        if(error.length>0){
                            t.$store.commit("core/setNotiPush", {
                                show: true,
                                group: "notiPush",
                                type: '5', // 1=success|2=info|3=error|4=loading|5=warning
                                title: 'Failed!',
                                text: error[0],
                                duration: 5000
                            });
                        }
                        else if(response.data.message && response.data.message.length>0){
                            t.$store.commit("core/setNotiPush", {
                                show: true,
                                group: "notiPush",
                                type: '5', // 1=success|2=info|3=error|4=loading|5=warning
                                title: 'Failed!',
                                text: response.data.message,
                                duration: 5000
                            });
                        }
                    } else {
                        let pushRefresh = this.$store.getters["ModApps/bRem/get_refresh_list"] + 1;
                        this.$store.commit("ModApps/bRem/set_refresh_list", pushRefresh);
                        this.getNotes(false);
                    }
                })
                .catch((error) => {
                    console.log(error);
                    //t.$refs.addGalley.value=null;
                    t.$store.commit("core/setLoadingModal", false);
                });
        },
        close() {
            this.$parent.$emit('closed-lateral');
        },
		getUsersList() {
			let t = this;
            return new Promise((resolve, reject) => {
			let colors = t.$store.getters['core/get_paletaDeColores'];
                window.master.post('usersListSec', {
                    user_id: t.f.user_id,
                    org_id: t.f.org_id,
                })
                .then((response) => {
                    let r = response.data;
                    t.userlist = [{
                        id: r.org.id,
                        account_id: r.org.account_id,
                        owner: r.org.bill_company_name,
                        firstname: r.org.bill_firstname,
                        lastname: r.org.bill_lastname,
                        email: r.org.bill_email,
                        pref_name: r.org.pref_name + ' ' + r.org.pref_lastname,
                        pref_email: r.org.pref_email,
                        classColor: (r.org.color) ? ((r.org.color != '') ? (r.org.color) : '#031099') : '#031099',
                        avatar: null,
                    }];
                    for (let i in r.users) {
                        if (r.users[i]) {
                            t.userlist.push({
                                id: r.users[i].id,
                                account_id: r.users[i].account_id,
                                owner: null,
                                firstname: r.users[i].firstname,
                                lastname: r.users[i].lastname,
                                email: r.users[i].email,
                                pref_name: r.users[i].pref_name + ' ' + r.users[i].pref_lastname,
                                pref_email: r.users[i].pref_email,
                                classColor: (r.users[i].color) ? ((r.users[i].color != '') ? (r.users[i].color) : colors[i]) : colors[i],
                                avatar: (r.users[i].avatar) ? r.users[i].ruta + r.users[i].avatar : null,
                            });
                        }
                    }
                    resolve(true);
                    console.log('usersListSec', t.userlist)
                })
                .catch((error) => {
                    console.log(error);
                });
            });
		},
		printAuthor(author_user_id){
            return this.userlist.find(r => { return r.account_id == author_user_id;});
		},
        getProfile(account_id){
            let profile = this.printAuthor(account_id);
            return profile ? profile.firstname + ' ' + profile.lastname + (profile.owner ? ' (Owner)' : '') : 'S/N';
        },
    },
    watch: {
        getPusher: function () {
            let t = this;
            if (t.getPusher != undefined) {
                if (t.getPusher.action == "actNote" && t.getPusher.data.org_id == window.localorgdata && t.getPusher.data.event_id == t.f.event_id) {
                    console.log('actNote', t.getPusher);
                    t.getNotes(false);
                }
            }
        },
    },
    computed: {
        ...mapGetters("core", {
            getPusher: "get_accitonPusher"
        }),
    }
}
</script>
<style lang="scss" scoped>
.table-bordered th,
.table-bordered td {
    border: 0px solid #dee2e6;
}

.container-comments {
    display: block;
    width: 100%;
    height: calc(100vh - 240px);
    overflow: hidden;
    overflow-y: auto;
}

ul.listComments {
    list-style: none;
    margin-bottom: 0px;
    padding-inline-start: 0px;
    margin-block-start: 0px;
}

.comments-content {
    position: relative;
    padding: 10px;
    margin-right: 20px;
    border: 1px solid #e4daff;
    border-radius: 10px;
    background: rgb(228 218 255 / 49%);
    margin-bottom: 20px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 10px
}
.comments-content.last-comment {
    background: rgb(228 218 255);
}

.date,
.by {
    font-size: 14px;
    line-height: 1.5;
    color: #bebebe;
    display: block;
}

.comment {
    font-size: 16px;
    line-height: 1.2;
    &::first-letter {
        padding-left: 50px;
    }
}
.comment b {color: #bebebe; margin-right: 5px;}
.comments-content button.closeIcon {}
.comment-body {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    align-content: flex-start;
}
.comment-info {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    align-content: flex-start;
}
.comment-avatar {
    display: flex;
    align-items: flex-start;
    position: relative;
    width: 100%;
    .label-assign{
        position: relative;
        display: flex;
        flex-direction: column;
        flex-wrap: nowrap;
        align-content: center;
        justify-content: center;
        align-items: center;
        margin-right: 10px;
        i.fa-user-circle{
            font-size: 20px;
            padding: 0px 1px;
            margin: auto;
            color:#ddd;
        }
        i.fa-user-circle.active{
            color:#555;
        }
        .avatarUser{
            width: 40px;
            height: 40px;
            display: flex;
            justify-content: center;
            align-items: center;
            margin: 0px;
            border: 1px solid #ccc;
            position: relative;
            z-index: 1;
            border-radius: 5%;
            font-size: 16px;
            font-weight: 900;
            background-color: #c4c4c4;
            color: #fff;
            text-transform: uppercase;
            &.avatarImg {
                background-color: transparent;
                border: 0px;
            }
            &.bg-avatar-choise{
                background-color: #ddd;
                color:#bbb;
                .plus-user{
                    position: relative;
                    right: -1px;
                }
            }
            span.labelAvatar{
                position: absolute;
                z-index: 1;
                width: 100%;
                height: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                letter-spacing: -1px;
            }
            img.imgAvatar {
                width: 40px;
                height: 40px;
                object-fit: cover;
            }
        }
    }
    &:hover{cursor: pointer;}
}
</style>
